import React from "react";
import { CirclePoint } from "../style";
import { OptionImage } from "../../product/style";

const SectionFillerOverrides = ({ group }) => {
  const sides = group?.sides || {};
  const propertyList = group?.property_list || [];

  const getShutterColorName = (colorId) => {
    const colorProperty = propertyList.find((p) => p.identifier === "color");
    const colorOption = colorProperty?.options.find(
      (o) => o.identifier === colorId
    );

    if (!colorOption) return "No color selected";

    return (
      <span className="d-inline-flex align-items-center gap-1">
        {colorOption.image && (
          <OptionImage
            src={colorOption.image}
            alt={colorOption.name}
            className="border border-dark rounded-circle me-2"
          />
        )}
        {colorOption.name}
      </span>
    );
  };

  const getThicknessLabel = (direction, thicknessSku) => {
    const options = group.end_panel_thickness_options?.[direction] || [];
    return (
      options.find((o) => o.sku === thicknessSku)?.name ||
      "No thickness selected"
    );
  };

  return (
    <div className="px-1 pt-1" style={{ width: "max-content" }}>
      {["left", "right", "top", "bottom"].map((direction) => {
        const side = sides[direction];
        if (!side) return null;

        const overrides = side.overrides || {};
        const hasOverrides = Object.keys(overrides).length > 0;
        const type = side.type;

        if (type === "none" && !hasOverrides) return null;

        const values = [];

        if (type !== "none") {
          values.push(type.charAt(0).toUpperCase() + type.slice(1));
        }

        if (overrides.height) values.push(`${overrides.height}mm`);
        if (overrides.width) values.push(`${overrides.width}mm`);
        if (overrides.depth) values.push(`${overrides.depth}mm`);
        if (overrides.extension != null) {
          const extValue =
            Number(overrides.extension) > 0
              ? `+${overrides.extension}mm`
              : `${overrides.extension}mm`;
          values.push(extValue);
        }
        if (overrides.shutter_color)
          values.push(getShutterColorName(overrides.shutter_color));
        if (overrides.thickness)
          values.push(getThicknessLabel(direction, overrides.thickness));

        return (
          <div
            key={direction}
            className="d-flex align-items-center flex-wrap gap-2 mb-1 pb-2"
          >
            <strong style={{ textTransform: "capitalize" }}>
              {direction}:
            </strong>
            {values.map((val, idx) => (
              <span key={idx} className="d-flex align-items-center gap-1 text-muted">
                <span>{val}</span>
                {idx < values.length - 1 && <CirclePoint />}
              </span>
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default SectionFillerOverrides;
